// extracted by mini-css-extract-plugin
export default {"controls":"CommentAdd_controls__Xmoil","field":"CommentAdd_field__krf6C"};